module.exports = __webpack_public_path__ + "media/images/icons/own_cooking-35ff55f066bfe0feafa2eb566abfc4b9.png";